import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { SettingsDropdown } from 'src/components'
import { LockIcon } from 'src/assets/icons'
import { ChangePasswordModal } from '../change-password-modal'
import { ETranslationNs } from 'src/types'

const ChangePasswordButton = () => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const [searchParams, setSearchParams] = useSearchParams()
  const passwordOpen = !!searchParams.get('password_open')
  const [open, setOpen] = useState(passwordOpen)

  useEffect(() => {
    if (passwordOpen) {
      setSearchParams((prev) => {
        prev.delete('password_open')
        return prev
      })
    }
  }, [setSearchParams, passwordOpen])

  const handleClose = () => setOpen(false)
  const handleChangePassword = () => setOpen(true)

  return (
    <>
      <SettingsDropdown
        onButtonClick={handleChangePassword}
        text={t('user-profile-change-password-button.v', { ns: ETranslationNs.UserProfile })}
        icon={<LockIcon />}
      />
      <ChangePasswordModal open={open} onClose={handleClose} />
    </>
  )
}

export { ChangePasswordButton }
